export interface UserOnboadingDetail {
    status: string;
    date_start: string;
    date_end: string;
}

export interface UserOnboading {
    search: UserOnboadingDetail;
    annonce: UserOnboadingDetail;
    ville: UserOnboadingDetail;
    search_save: UserOnboadingDetail;
    alert: UserOnboadingDetail;
    favoris_list: UserOnboadingDetail;
    compare: UserOnboadingDetail;
    pdf: UserOnboadingDetail;
    parameters: UserOnboadingDetail;

    finish: boolean;
    auto: boolean;
    open: boolean;
    dismiss: boolean;
    dismiss_date: string;
    show_historic: boolean;
    show_list_search: boolean;
    show_save_search: boolean;
    show_save_city_search: boolean;
    show_save_search_city_search: boolean;
    show_rate: boolean;
    show_calendly: boolean;
    popup_search_save: string;
    popup_search_fav: boolean;
    show_pro_popup: boolean;
}

export interface UserDashboard {
    pdf_profil: string;
    pdf_page: string[];
    pdf_kpi: string[];
    pdf_quality: string;
    sidebar_collapse: boolean;
    favorite_kpi: string[];
    search_kpi: string[];
}

export interface UserAnswer {
    profil: string;
}

export interface RateAnswer {
    general: number;
}

export interface Subscription {
    subscription_id: string;
    status: string;
    plan: string;
    duration: string;
    cancel_date: string;
    current_period_end: string;
}

export interface PaymentMethod {
    type: string;
    type_detail: string;
    exp_month: number;
    exp_year: number;
    last_4: string;
}

export interface User {
    created_at: string;
    id: number;
    email: string;
    firstname: string;
    lastname: string;
    code_filleul: string;
    code_parrainage: string;
    adress: string;
    city: string;
    zip_code: string;
    company_name: string;
    mailing: boolean;
    agence: number;
    notary_old: number;
    notary_new: number;
    default_work: number;
    default_work_value: number;
    other_fees: number;
    other_fees_min: number;
    other_fees_work: number;
    other_fees_work_min: number;
    agence_rental: number;
    rental_vacancy: number;
    other_bill: number;
    amount_rent_insurance: number;
    apport: number;
    duration: number;
    rate: number;
    rate_insurance: number;
    banking_fees: number;
    apport_notary: number;
    work_1: number;
    work_2: number;
    work_3: number;

    building_insurance: number;
    accouting_fees: number;
    deposit_fees: number;
    cfe_contribution: number;

    part_field: number;
    part_structure: number;
    part_facade: number;
    part_arrangment: number;
    part_equipment: number;
    amort_duration_furniture: number;
    amort_duration_agency_fees: number;
    amort_duration_work: number;
    amort_duration_structure: number;
    amort_duration_facade: number;
    amort_duration_arrangment: number;
    amort_duration_equipment: number;

    fiscal_choice: string;
    shares_number: number;
    annual_income: number;
    annual_income_sci: number;

    plan: string;
    exclude: boolean;
    pro_plan: string;
    pro_data: string;
    api_plan: string;
    api_plan_credit: number;
    api_plan_renew_date: string;
    api_ayg_credit: number;
    api_ayg_expire_date: string;

    ai_credit: number;
    ai_credit_renew_date: string;
    subscription_api: Subscription;

    total: number;
    valid_filleul: boolean;

    form: boolean;
    rate_form: boolean;
    news_form: boolean;
    popup_endtrial: boolean;
    header_form: boolean;

    p: string;

    user_dashboard: UserDashboard;
    user_onboarding: UserOnboading;
    answer: UserAnswer;
    rate_answer: RateAnswer;

    subscription: Subscription;
    payment_method: PaymentMethod;

    double_auth_code: string;
    double_auth_code_at: string;
    double_auth_disable: boolean;

    trial_end_date: string;
    trial_plus_end_date: string;
    show_trial_inc: boolean;

    promo_end_date: string;
    show_promo: boolean;

    // Publication d'annonces sur le moteur de recherche (posé depuis l'admin)
    publisher: boolean;
    publisher_contact: string; // 'direct' | 'rappel'
    publisher_company: string;
}

// Plan partenaire (posé depuis l'admin) : plafonds, miroir de l'API.
export const PARTNER_MAX_SEARCH = 3;
export const PARTNER_MAX_SEARCH_CITY = 3;
